import { Component, OnInit, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { ValidvalueselectService } from './validvalueselect.service';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../services/static-data.service';

@Component({
  selector: 'app-validvalueselect', 
  templateUrl: './validvalueselect.component.html',
  styleUrls: ['./validvalueselect.component.css']
})
export class ValidvalueselectComponent implements OnInit {

  @Input() showNoneOption: boolean = false;
  @Input() validvaluename: string;
  @Input() selectedValue: string;
  @Input() vvplaceholder: string;
  @Input() vvlabel: string;
  @Input() dataSource: EnumValidValueItemModel[];
  @Input() style: string;
  @Input() fitParentWidth: boolean = false;
  @Input() disabled: boolean = false;

  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() properyName: string = 'ValidValueItemId';
  // @Output() selectedObjectChange: EventEmitter<EnumValidValueItemModel> = new EventEmitter<EnumValidValueItemModel>();
  public theValidValueList: EnumValidValueItemModel[];

  constructor(private _validvalueService: ValidvalueselectService,
              private staticDataService: StaticDataService) { }

  ngOnInit() {
    if (!this.dataSource) {
      if (this.staticDataService.isReady) {
        this.theValidValueList = this.staticDataService.getValidValueItemsByValidValueName(this.validvaluename);
      } else {
        this.staticDataService.validValuesReadyEvent.subscribe((res) => {
          this.theValidValueList = this.staticDataService.getValidValueItemsByValidValueName(this.validvaluename);
        });
      }
    } else {
      this.theValidValueList = this.dataSource;
    }

    /*if (this.dataSource === undefined) {
      this._validvalueService.getValidValueList(this.validvaluename).subscribe(data => {
          this.theValidValueList = data;
        }
      );
    } else {
      this.theValidValueList = this.dataSource;
    }*/
  }

  onItemSelect(newValue) {
    // this.selectedValue
    this.selectedValueChange.emit(newValue);
  }
}
